import { render, staticRenderFns } from "./SettingsPersonal.vue?vue&type=template&id=15886856"
import script from "./SettingsPersonal.vue?vue&type=script&lang=js"
export * from "./SettingsPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports